import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import WaveSurfer from "wavesurfer.js";
import style from './AudioPlayer.module.css'
import { BsFillPauseFill, BsPlayFill } from "react-icons/bs";
import CircularProgressBar from "../Visual-utilities/CircularProgressBar";
import { IoReloadOutline } from "react-icons/io5";


const Waveform = ({ src ,color,background ,progressColor }) => {


  const formWaveSurferOptions = ref => ({
    container: ref,
    waveColor: color,
    progressColor:progressColor,
    cursorColor: 'blue',
    barWidth: 2,
    barRadius: 2,
    barGap: 3,
    barMinHeight: 1,
    cursorWidth: 1,
    responsive: true,
    height: 30,
    fillParent: true,
    // If true, normalize by the maximum peak instead of 1.0.
    normalize: true,
    // Use the PeakCache to improve rendering speed of large waveforms.
    partialRender: true,
    //backend:'MediaElement',
    //mediaType:"audio"
  });
  




  const containerRef = useRef();
  const waveSurferRef = useRef({
    isPlaying: () => false,
  });
  const [isPlaying, toggleIsPlaying] = useState(false);
  const [isLoaded, toggleIsLoaded] = useState(false);

  const [currentTime, setCurrentTime] = useState(0);

  const [loadingProgress, setLoadingProgress] = useState(-40);

const [error, setError] = useState(false);

  function startWavePlayer(){
    setError(false);
    const options = formWaveSurferOptions(containerRef.current);
    waveSurferRef.current = WaveSurfer.create(options);

    waveSurferRef.current.load(src);

    waveSurferRef.current.on("ready", function () {
      toggleIsLoaded(true);
      // waveSurferRef.current.playPause();
      setCurrentTime(waveSurferRef.current.getDuration().toFixed(0))

    });

    const timeout = setInterval(() => {
      if (waveSurferRef.current.isPlaying())
      setCurrentTime(waveSurferRef.current.getCurrentTime());
    }, 500);
    waveSurferRef.current.on('pause', function () {
      // waveSurferRef.params.container.style.opacity = 0.9;
    });

    waveSurferRef.current.on("audioprocess", () => {
     
        //  setCurrentTime(waveSurfer.getCurrentTime().toFixed(2));
      
    });

    waveSurferRef.current.on("error", (e) => {
     setError(true)
console.log('waveform error',e)
    
  });
    waveSurferRef.current.on('play', () => { toggleIsPlaying(true) })
    waveSurferRef.current.on('finish', () => { toggleIsPlaying(false) })
    waveSurferRef.current.on('loading', (val) => {
      // console.log('loading',val)
      setLoadingProgress(val);
    })

    // Removes events, elements and disconnects Web Audio nodes.
    // when component unmount
    return () => {
      waveSurferRef.current.destroy();
      clearInterval(timeout);
    }
  }
  //console.log("the audio", src);
  useEffect(() => {
    startWavePlayer()

  }, []);


function handleButtonClick(){

  if(!error){waveSurferRef.current.playPause();
    toggleIsPlaying(waveSurferRef.current.isPlaying());}
    else{
      containerRef.current.innerHTML = "";
      startWavePlayer()
    }
  
}



  function formatMinutes(minutes) {
    return minutes < 10 ? `0${minutes}` : minutes;
  }

  function formatSeconds(seconds) {
    return seconds < 10 ? `0${seconds}` : seconds;
  }



  return (
    <div className={style.audioContainer}
    style={{background:background,}}>
      <div className={style.audioPlayer}>
        <button
          onClick={handleButtonClick}
         style={{color:color,}}
        >
          {error?(
            <IoReloadOutline size="3em"/>
          )
          :!isLoaded ? (
            <CircularProgressBar
              strokeWidth="4"
              sqSize="35"
              percentage={loadingProgress}
            />

          ) : isPlaying ? (
            <BsFillPauseFill size="3em" />
          ) : (
            <BsPlayFill size="3em" />
          )}
        </button>

        <div ref={containerRef} className={style.waves} />

        <div className={style.currentTime}
         style={{color:color,}}>

          {formatMinutes((currentTime / 60).toFixed(0)) + ":" +
            formatSeconds((currentTime % 60).toFixed(0))}

        </div>

      </div>

      <>

       
      
      </>


    </div>
  );
};

Waveform.propTypes = {
  src: PropTypes.string.isRequired,
};



export default Waveform;